export default __webpack_public_path__ + "static/media/SaraKiselovskaMobile.59dfa4fa.png";